import { FC } from "react";
import { IonSpinner } from "@ionic/react";
import { AllieSpinnerProps } from "./Spinner.types";

export const AllieSpinner: FC<AllieSpinnerProps> = (props) => (
  <IonSpinner {...props} />
);
